export default {"src":"/_next/static/media/ev.54a7ab31.svg","height":44,"width":46,"blurWidth":0,"blurHeight":0};